import PropTypes from 'prop-types'
import { formatearFecha } from '../helpers/helper'
import styles from './ItemLista.module.css'

export const ItemLista = ({ lista, onEditar, onEliminar }) => {
  if (!lista) {
    return null
  }

  const cantidadItems = Array.isArray(lista.grilla) ? lista.grilla.length : 0
  return (
    <div className={styles.card}>
      <h4 className={styles.cardTitle}>{lista.nombreLista}</h4>
      <div className={styles.cardBody}>
        <div className={styles.textMuted}>
          <p>
            <strong>Vigencia: </strong>
            {formatearFecha(lista.vigenciaDesde, 'F')} -
            {formatearFecha(lista.vigenciaHasta, 'F')}
          </p>
          <p>
            <strong> Cantidad de items lista: </strong>
            {cantidadItems}
          </p>
        </div>
      </div>

      <div className={styles.btnContainer}>
        <button
          type="button"
          className={`${styles.btn} ${styles.btnOutlinePrimary}`}
          onClick={() => onEditar(lista)}
        >
          <i className="bi bi-pencil"></i>
        </button>

        <button
          type="button"
          className={`${styles.btn} ${styles.btnOutlineDanger}`}
          onClick={() => onEliminar(lista)}
        >
          <i className="bi bi-trash"></i>
        </button>
      </div>
    </div>
  )
}

ItemLista.propTypes = {
  lista: PropTypes.object,
  onEditar: PropTypes.func,
  onEliminar: PropTypes.func
}
